import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../../../../styledComponents/styles/Paragraph.styled';
import EmailCheck from '../../../../../styledComponents/styles/EmailCheck.styled';

const Container = styled.div`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #373737;
`;

const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

const Label = styled.label`
  color: ${({ theme }) => theme.textInput.label.fontColor};
  font-family: ${({ theme }) => theme.textInput.label.fontFamily};
  font-size: ${({ theme }) => theme.textInput.label.fontSize};
  font-weight: ${({ theme }) => theme.textInput.label.fontWeight};
`;

const Required = styled.span`
  color: ${({ theme }) => theme.defaults.errorColor};
  padding-left: 5px;
`;
export default function QuestionRecommendationDisplayPreview({ question }) {
  const updatedInstruction = !!question.applicant_instructions ? question.applicant_instructions.replace(/<p><\/p>/g, '<br />') : '';
  return (
    <Container>
      <InputContainer>
        <Label htmlFor={question.id}>
          {question.label}
          {question.required && <Required>*</Required>}
        </Label>
        <Paragraph
          aria-label={question.label}
          id={'recommendation_instructions_applicant'}
          openSans
          dangerouslySetInnerHTML={{
            __html: updatedInstruction,
          }}
        />
        <EmailCheck
          aria-label={question.label}
          id={'recommendation-email'}
          label={`Recommender's Email`}
          placeholder={`Enter recommender's email`}
          buttonText={'Send'}
          openSans
          required={question.required}
          readOnly
          disabled={true}
          icon={'LockClosed'}
        />
      </InputContainer>
    </Container>
  );
}
